module.exports = __webpack_public_path__ + "static/img/back3.48b64655.jpg";